var _circle, _circle2, _circle3, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotAssigned(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 114,
    height: 113,
    viewBox: "0 0 114 113",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 57,
    cy: 56.5,
    r: 56.25,
    fill: "#D8270E",
    fillOpacity: 0.2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 57.25,
    cy: 56.75,
    r: 37.5,
    fill: "#D8270E"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 57,
    cy: 56.5,
    r: 47.25,
    fill: "#D8270E",
    fillOpacity: 0.4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M57 65V57M57 49H57.02M37 50.0455V63.9545C37 64.4437 37 64.6883 37.0553 64.9185C37.1043 65.1225 37.1851 65.3176 37.2947 65.4966C37.4184 65.6984 37.5914 65.8714 37.9373 66.2173L47.7827 76.0627C48.1286 76.4086 48.3016 76.5816 48.5034 76.7053C48.6824 76.8149 48.8775 76.8957 49.0815 76.9447C49.3117 77 49.5563 77 50.0455 77H63.9545C64.4437 77 64.6883 77 64.9185 76.9447C65.1225 76.8957 65.3176 76.8149 65.4966 76.7053C65.6984 76.5816 65.8714 76.4086 66.2173 76.0627L76.0627 66.2173C76.4086 65.8714 76.5816 65.6984 76.7053 65.4966C76.8149 65.3176 76.8957 65.1225 76.9447 64.9185C77 64.6883 77 64.4437 77 63.9545V50.0455C77 49.5563 77 49.3117 76.9447 49.0815C76.8957 48.8775 76.8149 48.6824 76.7053 48.5034C76.5816 48.3016 76.4086 48.1286 76.0627 47.7827L66.2173 37.9373C65.8714 37.5914 65.6984 37.4184 65.4966 37.2947C65.3176 37.1851 65.1225 37.1043 64.9185 37.0553C64.6883 37 64.4437 37 63.9545 37H50.0455C49.5563 37 49.3117 37 49.0815 37.0553C48.8775 37.1043 48.6824 37.1851 48.5034 37.2947C48.3016 37.4184 48.1286 37.5914 47.7827 37.9373L37.9373 47.7827C37.5914 48.1286 37.4184 48.3016 37.2947 48.5034C37.1851 48.6824 37.1043 48.8775 37.0553 49.0815C37 49.3117 37 49.5563 37 50.0455Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotAssigned);
export default __webpack_public_path__ + "static/media/not-assigned.e0ca5a1d49dca4cfba90276b3e057404.svg";
export { ForwardRef as ReactComponent };